import { HTTPError as KyHttpError } from 'ky';

// Note: Just wrapping Ky errors so they're more easily accessible from outside the http package + for future extensibility
export class HttpError<T = unknown> extends KyHttpError<T> {
    public responseContent: T | string | null = null;
    public fullErrorMessage?: string;

    static async fromKyError<T = unknown>(kyError: KyHttpError) {
        const error = new HttpError<T>(kyError.response, kyError.request, kyError.options);
        error.fullErrorMessage = error.message;

        let urlWithoutPrefix = '';

        if (kyError.options?.prefixUrl) {
            urlWithoutPrefix = kyError.request?.url?.replace(kyError.options.prefixUrl, '') ?? '';
        } else {
            urlWithoutPrefix = kyError.request?.url?.split('/').at(-1) ?? 'Unknown URL';
        }

        error.message = `Fetch Error: ${urlWithoutPrefix}: ${kyError.response?.status ?? 'Unknown Status'}`;

        try {
            error.responseContent = await kyError.response.json();
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (jsonError) {
            try {
                error.responseContent = await kyError.response.text();
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (textError) {
                error.responseContent = 'Failed to parse response content';
            }
        }

        return error;
    }
}
